// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17qTb","newExpiryDate":"styles_newExpiryDate__3fidR","footer":"styles_footer__3lMsV"};